import { useUser } from "../../context/UserContext";
import { Link } from "react-router-dom";

export default function Header() {
    const { user } = useUser()

    return <header className="site-header light text-light transparent">
        <div className="header-contents">


            <a href="/" className="logo">

                <img src="/img/logo-light.png" className="logo-light" alt="" />
            </a>
            <div className="right-part-nav main-navigation">
                {user ?
                    <div className="btn-inner me-sm-2">
                        <Link to="/dashboard" className="btn btn-primary ">Wallet</Link>
                    </div> :
                    <>
                        <ul className="menu nav-menu">
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-79">
                                <Link to="/login" className="primary-menu-link">Sign In</Link>
                            </li>
                            <li className="menu-item menu-item-type-post_type menu-item-object-page menu-item-has-children menu-item-79">
                                <Link to="/register" className="primary-menu-link">Sign Up</Link>
                            </li>

                        </ul>
                        <div className="btn-inner me-sm-2">
                            <Link to="/dashboard" className="btn btn-primary ">Wallet</Link>
                        </div>
                    </>
                }

            </div>



        </div>
    </header>
}